import PocketBase from 'pocketbase';

const pb = new PocketBase('https://globe.jugendeinewelt.at');

export default pb;
